/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseTemplate } from '../../models/automatic-pause-template';

export interface GetAutomaticPauseTemplate$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
}

export function getAutomaticPauseTemplate(http: HttpClient, rootUrl: string, params: GetAutomaticPauseTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticPauseTemplate>> {
  const rb = new RequestBuilder(rootUrl, getAutomaticPauseTemplate.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticPauseTemplate>;
    })
  );
}

getAutomaticPauseTemplate.PATH = '/ordering/automatic-pause-templates/{templateId}';
